import {
  Avatar,
  Group,
  Button,
  Divider,
  Text,
  ActionIcon,
  Title,
  Box,
  SimpleGrid,
  UnstyledButton,
} from "@mantine/core";
import {
  IconBuildingBank,
  IconBuildingSkyscraper,
  IconCalendar,
  IconCategory,
  IconCategory2,
  IconCircleLetterG,
  IconCircleNumber1,
  IconComponents,
  IconCurrency,
  IconExchange,
  IconGift,
  IconGlass,
  IconClock,
  IconKey,
  IconLadder,
  IconMoneybag,
  IconNumber,
  IconNumber1,
  IconServicemark,
  IconNetwork,
  IconStar,
  IconRobot,
  IconTicket,
  IconTable,
  IconUsers,
  IconList,
  IconReceiptTax,
  IconCheckbox,
  IconBell,
  IconForms,
  IconShieldCheck,
  IconBrandGoogleDrive,
} from "@tabler/icons";
import React, { useState, useEffect } from "react";
import { useTabNavigate } from "../../hooks/useTabNavigate";
import { Page } from "../../layout/page";
import "to-color-string";
import { useTranslation } from "react-i18next";

const HomepageSettings = [
  {
    icon: IconCalendar,
    label: "Calendar",

    description: "Add or edit company events, training and any special dates.",
    link: "/management/calendarEvent",
  },

  {
    icon: IconMoneybag,
    // color: "#ffec00",
    label: "Consultant Incentive",
    description: "Add or edit latest consultant incentive programs.",
    link: "/management/consultantIncentive",
  },

  {
    icon: IconStar,
    // color: "#ffec00",
    label: "Client Promotion",
    description: "Add or edit latest client promotion programs from providers.",
    link: "/management/clientPromotion",
  },

  {
    icon: IconCircleNumber1,
    // color: "#ffec00",
    label: "Top Rankings",
    description:
      "Add or edit rankings of consultant based on different criteria.",
    link: "/management/topRanking",
  },
];

const ProductSettings = [
  {
    icon: IconComponents,
    // color: "#ffec00",
    label: "Product Category",

    description: "Add or edit product category.",
    link: "/operation/productCategory",
  },

  {
    icon: IconCategory2,
    label: "Product Type Group",
    description: "Add or edit class groups.",
    link: "/operation/productTypeGroup",
  },
  {
    icon: IconCategory,
    // color: "#ffec00",
    label: "Product Type",

    description: "Add or edit product types.",
    link: "/operation/productType",
  },

  {
    icon: IconBuildingSkyscraper,
    // color: "#ffec00",
    label: "Product Provider",

    description: "Add or edit product providers.",
    link: "/operation/provider",
  },

  {
    icon: IconList,
    label: "Approval Fund List",
    description: "Manage approved fund lists for investment products.",
    link: "/operation/approvalFundList",
  },

  {
    icon: IconExchange,
    label: "Investment Transaction",
    description:
      "Configure investment transaction rules such as minimum Non-Wrap upfront fee.",
    link: "/management/investmentTransactionSetting",
  },
];

const ClientSettings = [
  {
    icon: IconShieldCheck,
    label: "Risk Control",
    description: "Configure client risk control options such as source of fund.",
    link: "/management/riskControlSetting",
  },
];

const UserSettings = [
  {
    icon: IconUsers,
    label: "User",
    link: "/operation/user",
    linkId: "O7",
    group: "Operation",
    description: "Manage user accounts, profiles, and access.",
  },
  {
    icon: IconShieldCheck,
    label: "User Role",
    link: "/operation/userRole",
    group: "Operation",
    description:
      "Configure roles and permissions for menus, features, and access rights.",
  },
  {
    icon: IconCircleLetterG,
    label: "User Group",
    link: "/operation/userGroup",
    linkId: "O8",
    group: "Operation",
    description: "Create group of users for commission overriding.",
  },
];

const CommissionSettings = [
  {
    icon: IconLadder,
    // color: "#ffec00",
    label: "Overriding Plan",

    description: "Add or edit commission overriding plans.",
    link: "/management/commissionOverridingPlan",
  },
  {
    icon: IconTable,
    // color: "#ffec00",
    label: "Commission Schedule",

    description: "Create or Update the commission schedule.",
    link: "/management/commissionSchedule",
  },
  {
    icon: IconUsers,
    label: "Teams",
    link: "/management/team",
    linkId: "O9",
    group: "Management",
    description: "Sales team management.",
  },
  {
    icon: IconGift,
    // color: "#ffec00",
    label: "Allowance Plan",

    description: "Add or edit available allowance plans for consultant.",
    link: "/management/allowancePlan",
  },
  {
    icon: IconExchange,
    // color: "#ffec00",
    label: "Exchange Rates",

    description: "Update the latest currency exchange rates.",
    link: "/management/exchangeRate",
  },
];

const AISettings = [
  {
    icon: IconRobot,
    label: "AI Prompts",
    description: "Add or edit AI prompts.",
    link: "/management/aiPrompt",
  },
  {
    icon: IconNetwork,
    label: "AI Workflow",
    description: "Add or edit AI workflow.",
    link: "/management/aiWorkflow",
  },
];

const AccountSettings = [
  {
    icon: IconBuildingBank,
    label: "HSBC MRI",
    description: "Configure HSBC MRI bank transfer settings for payroll.",
    link: "/account/hsbcMriSetting",
  },
  {
    icon: IconReceiptTax,
    label: "IR56M",
    description:
      "Configure employer details for IR56M commission reporting to IRD.",
    link: "/account/ir56mSetting",
  },
];

const OtherSettings = [
  {
    icon: IconBuildingBank,
    // color: "#ffec00",
    label: "Organization",
    description: "Edit the organization details.",
    link: "/management/organization",
  },
  {
    icon: IconBuildingSkyscraper,
    label: "Companies",
    description: "Manage extra companies / workspaces for multi-entity brokers.",
    link: "/management/company",
  },

  {
    icon: IconExchange,
    label: "Data Migration",
    description:
      "Import data from external broker systems or MBID templates.",
    link: "/management/dataMigration",
  },
  {
    icon: IconForms,
    label: "Extra Fields",
    description:
      "Configure custom fields for User and Client records, import templates, and edit forms.",
    link: "/management/extraFields",
  },
  {
    icon: IconTicket,
    // color: "#ffec00",
    label: "Ticket Types",
    description:
      "Add Types of ticket and assign backend office staffs to handle ticket.",

    link: "/management/ticketTypes",
  },
  {
    icon: IconBrandGoogleDrive,
    label: "File Backup Sync",
    description: "Mirror MBID uploads to Google Drive or other backup providers.",
    link: "/operation/fileBackupSyncSetting",
  },
  {
    icon: IconGlass,
    label: "Order Services Types",
    description: "Add Types of order supplementary (service).",

    link: "/management/orderServiceType",
  },
  {
    icon: IconKey,
    label: "API Keys",
    description:
      "Create API keys to connect to MBID directly without traditional login.",
    link: "/management/apiKey",
  },
  {
    icon: IconClock,
    label: "Cron Jobs",
    description: "View and manage scheduled background jobs.",
    link: "/management/cronJob",
  },
  {
    icon: IconCheckbox,
    label: "Approval Process",
    description:
      "Configure multi-step approval workflows for entity changes.",
    link: "/management/mcaProcess",
  },
  {
    icon: IconBell,
    label: "Notification Rules",
    description: "Configure automated notification rules for entity changes.",
    link: "/management/notificationRules",
  },
  {
    icon: IconBell,
    label: "Notification Logs",
    description: "View audit trail of sent notifications.",
    link: "/management/notificationLogs",
  },
];
const SettingSections = [
  {
    label: "Homepage",
    settings: HomepageSettings,
  },
  {
    label: "Products",
    settings: ProductSettings,
  },
  {
    label: "Client",
    settings: ClientSettings,
  },
  {
    label: "User",
    settings: UserSettings,
  },
  {
    label: "Commissions",
    settings: CommissionSettings,
  },
  {
    label: "AI",
    settings: AISettings,
  },
  {
    label: "Account",
    settings: AccountSettings,
  },
  {
    label: "Others",
    settings: OtherSettings,
  },
];

const SettingButton = ({ setting }) => {
  const tabNav = useTabNavigate();
  const { label, description, color, link } = setting;
  const { t } = useTranslation();
  return (
    <UnstyledButton onClick={() => tabNav.open({ pathname: link })}>
      <Group maw={300} noWrap align={"start"}>
        <ActionIcon
          size="xl"
          radius="xl"
          variant="light"
          bg={label.toColorString()}
          // bgp={color}
          onClick={() => tabNav.open({ pathname: link })}
        >
          <setting.icon size={15} color={"white"} />
        </ActionIcon>
        <span>
          <Title order={6}> {t(label)} </Title>
          <Text size={"xs"} color="dimmed" lineClamp={2}>
            {t(description)}
          </Text>
        </span>
      </Group>
    </UnstyledButton>
  );
};

const SettingSection = ({ section, spacing = 40, cols = 3 }) => {
  const { label, settings } = section;
  const { t } = useTranslation();

  return (
    <Box mb={100}>
      <Text size={"sm"} weight={500}>
        {t(label)}
      </Text>
      <Divider mb={"xl"} mt="xs" />

      <SimpleGrid cols={cols} spacing={spacing}>
        {settings.map((setting) => (
          <SettingButton key={setting.label} setting={setting} />
        ))}
      </SimpleGrid>
    </Box>
  );
};

const Setting = ({}) => {
  return (
    <Page title={"Settings"}>
      {SettingSections.map((s) => (
        <SettingSection key={s.label} section={s} />
      ))}
    </Page>
  );
};

export default Setting;
